import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// 路由懒加载
const Index = () => import('views/index') // 首页
const ArticleDetail = () => import('views/articleDetail') // 文章
const Register = () => import('views/Register') // 注册页
const MemberCenter = () => import('views/memberCenter') // 会员中心
const Activity = () => import('views/SpringActivity/activity')
const SpringRegister = () => import('views/SpringActivity/SpringRegister')
const Rule = () => import('views/SpringActivity/Rule')
const Xxltg = () => import('views/xxltg') // 会员中心
const Semshenhe = () => import('views/Semshenhe')
const Nfw = () => import('views/nfw')
const Hbfwz = () => import('views/hbfwz')
const Zndt = () => import('views/zndt') // 智能定投
const Zndthb = () => import('views/zndthb')
const Wenzhang = () => import('views/Wenzhang')
const Jianban = () => import('views/Jianban')
const goldRegister = () => import('views/goldRegister')
const Lottery = () => import('views/lottery')
const NewGoldRegister = () => import('views/newGoldRegister')
const SecurityFinancing = () => import('views/securityFinancing')
const SecurityRule = () => import('views/securityRule')
const UserAgreement = () => import('views/userAgreement')
const Insurance = () => import('views/insurance')
const erWeiMa = () => import('views/erweima')
const freeMa = () => import('views/freema')
const AccountRegister = () => import('views/accountRegister')
const BurstAccountRegister = () => import('views/burstAccountRegister')
const HightTempActivity = () => import('views/hightTempActivity')
const Dvzs = () => import('views/dvzs')
const NewAccountRegister = () => import('views/newAccountRegister')
const Jinbi = () => import('views/jinbi')
const SafeFund = () => import('views/safeFund')
const PolarisDetail = () => import('views/polarisDetail')
const PolarisRegister = () => import('views/polarisRegister')
const SchoolSeason = () => import('views/schoolSeason')
const XimaLive = () => import('views/ximalive')
const LcmfPolicy = () => import('views/lcmfPolicy') // 隐私政策
const LcmfSDK = () => import('views/lcmfSDK') // 隐私政策
const LcmfAgreement = () => import('views/lcmfAgreement') // 理财魔方协议
const BankSigning = () => import('views/bankSigning') // 招商银行签约
const ZsReturn = () => import('views/zsReturn') // 招商银行签约结束页
const ReportFlow = () => import('views/ReportFlow') // 大数据年报
const accountRegisterAuth = () => import('views/accountRegisterAuth') // 大数据年报注册
const NewAccountRegisterDy = () => import('views/NewAccountRegisterDy') // 抖音
const NewAccountRegisterQn = () => import('views/newAccountRegisterQn') // 启牛
const TradeRule = () => import('views/tradeRule') // 交易规则
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '理财魔方-您的智能财富管家'
      }
    },
    {
      path: '/article_detail/:id',
      name: 'ArticleDetail',
      component: ArticleDetail,
      meta: {
        title: '理财魔方-您的智能财富管家',
        keepAlive: true // 需要缓存的组件
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/memberCenter',
      name: 'MemberCenter',
      component: MemberCenter,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/springRegister',
      name: 'SpringRegister',
      component: SpringRegister,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/rule',
      name: 'Rule',
      component: Rule,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/xxltg',
      name: 'Xxltg',
      component: Xxltg,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/newAccountRegisterDy', // 抖音
      name: 'NewAccountRegisterDy',
      component: NewAccountRegisterDy,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/newAccountRegisterQn', // 启牛
      name: 'NewAccountRegisterQn',
      component: NewAccountRegisterQn,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/semshenhe',
      name: 'Semshenhe',
      component: Semshenhe,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/nfw',
      name: 'Nfw',
      component: Nfw,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/hbfwz',
      name: 'Hbfwz',
      component: Hbfwz,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/zndt', // 智能定投
      name: 'Zndt',
      component: Zndt,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/zndthb', // 智能定投红包
      name: 'Zndthb',
      component: Zndthb,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/wenzhang', // 智能定投红包
      name: 'Wenzhang',
      component: Wenzhang,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/jianban',
      name: 'Jianban',
      component: Jianban,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/goldRegister', // 体验金注册页
      name: 'goldRegister',
      component: goldRegister,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/lottery', // 抽奖
      name: 'Lottery',
      component: Lottery,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/newGoldRegister', // 体验金其他渠道
      name: 'NewGoldRegister',
      component: NewGoldRegister,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/tradeRule', // 交易规则
      name: 'TradeRule',
      component: TradeRule,
      meta: {
        keepAlive: false, // 需要缓存的组件
      }
    },
    {
      path: '/securityFinancing', // 体验金其他渠道
      name: 'SecurityFinancing',
      component: SecurityFinancing,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/securityRule', // 体验金其他渠道
      name: 'SecurityRule',
      component: SecurityRule,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/userAgreement', // 用户协议
      name: 'UserAgreement',
      component: UserAgreement,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/insurance', // 保险
      name: 'Insurance',
      component: Insurance,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/erweima', // 二维码
      name: 'erWeiMa',
      component: erWeiMa,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/freema', // 二维码
      name: 'freeMa',
      component: freeMa,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/accountRegister', // 二维码
      name: 'AccountRegister',
      component: AccountRegister,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/burstAccountRegister', // 二维码
      name: 'BurstAccountRegister',
      component: BurstAccountRegister
    },
    {
      path: '/HightTempActivity', // 用户协议
      name: 'HightTempActivity',
      component: HightTempActivity,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/dvzs', // 二维码
      name: 'Dvzs',
      component: Dvzs,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/newAccountRegister', // 马红漫
      name: 'NewAccountRegister',
      component: NewAccountRegister,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/jinbi', // 金币
      name: 'Jinbi',
      component: Jinbi,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/safeFund', // 金币
      name: 'SafeFund',
      component: SafeFund,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/polarisDetail', // 星领投组合详情
      name: 'PolarisDetail',
      component: PolarisDetail,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/polarisRegister', // 注册星领投
      name: 'PolarisRegister',
      component: PolarisRegister,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/schoolSeason', // 注册星领投
      name: 'SchoolSeason',
      component: SchoolSeason,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/ximalive', // 喜马拉雅
      name: 'XimaLive',
      component: XimaLive,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/lcmfPolicy', // 理财魔方policy
      name: 'LcmfPolicy',
      component: LcmfPolicy,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/lcmfSDK', // 理财魔方sdk
      name: 'LcmfSDK',
      component: LcmfSDK,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/lcmfAgreement', // 理财魔方协议
      name: 'LcmfAgreement',
      component: LcmfAgreement,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/bankSigning', // 招商银行签约
      name: 'BankSigning',
      component: BankSigning,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/zsReturn', // 招商银行签约
      name: 'ZsReturn',
      component: ZsReturn,
      meta: {
        keepAlive: false // 需要缓存的组件
      }
    },
    {
      path: '/ReportFlow', // 大数据年报
      name: 'ReportFlow',
      component: ReportFlow,
      meta: {
        keepAlive: false // 大数据年报
      }
    },
    {
      path: '/accountRegisterAuth', // 大数据年报
      name: 'accountRegisterAuth',
      component: accountRegisterAuth,
      meta: {
        keepAlive: false // 大数据年报
      }
    },
    {
      path: '/lcmf',
      name: 'lcmf',
      component: Index,
      meta: {
        keepAlive: false
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js